<template>
    <DialogLayout>
        <h3 class="Modal__title">Paiement de l'hébergement</h3>
        <form @submit.prevent="handleSubmit" class="FormMaterial m-t-30">
            <div v-if="fullnameToVerify" class="text-center">
                <h2>Confirmez-vous être {{ fullnameToVerify }} ?</h2>
                <div class="text-center m-t-30">
                    <button @click="handleInvalid" class="Btn Btn--primary Btn--stroked m-r-10">
                        <span>Non</span>
                    </button>
                    <button @click="handleValid" class="Btn Btn--primary Btn--gradient Btn--shadow">
                        <span>Oui</span>
                    </button>
                </div>
            </div>
            <div v-else>
                <div class="Form__group">
                    <label for="matricule">Matricule</label>
                    <div class="m-b-5">
                        <input class="Form__input" type="text" id="matricule" name="matricule"
                               v-model="data.matricule"
                               @select="() => handleChange('matricule')"
                        >
                    </div>
                    <span v-if="errors.matricule">{{ errors.matricule[0] }}</span>
                </div>
                <div class="Form__group">
                    <label for="matricule">CFA</label>
                    <div class="m-b-5">
                        <multiselect
                            open-direction="bottom"
                            class="Select Select--small"
                            :searchable="false"
                            :show-labels="false"
                            placeholder="Sélectionnez"
                            @select="() => handleChange('region')"
                            key="id"
                            :allow-empty="false"
                            :options="accommodationRegions"
                            label="label"
                            v-model="data.region">
                            <span slot="noOptions">Aucun élément.</span>
                        </multiselect>
                    </div>
                    <span v-if="errors.region">{{ errors.region[0] }}</span>
                </div>
                <div class="text-center m-t-30">
                    <button :disabled="loading" type="submit" class="Btn Btn--primary Btn--gradient Btn--shadow">
                        <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                        <span v-else>Continuer</span>
                    </button>
                </div>
            </div>
        </form>
    </DialogLayout>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Api from "../../services/Api";
import ModalBus from "../../eventBus";
import DialogLayout from "./Layouts/DialogLayout";
import {getters} from "../../store";

export default {
    props: ['isOpen'],
    components: {DialogLayout, Multiselect},
    data: function () {
        return {
            data: {
                matricule: getters.user()?.profile?.matricule,
                region: null,
            },
            fullnameToVerify: null,
            paymentLink: null,
            loading: false,
            errors: {},
        }
    },
    computed:{
        accommodationRegions: function(){
            return window.accommodationRegions ?? [];
        }
    },
    watch: {
        isOpen: function(newVal, oldVal) {
            this.data = {
                matricule: getters.user()?.profile?.matricule,
                region: null,
            };
            this.fullnameToVerify = null;
            this.paymentLink = null;
            this.loading = false;
            this.errors = {};
        }
    },
    methods: {
        handleChange: function (name) {
            delete this.errors[name];
        },
        handleInvalid(){
            this.fullnameToVerify = null;
            this.paymentLink = null
        },
        handleValid(){
            window.open(this.paymentLink);
            ModalBus.close();
        },
        async handleSubmit() {
            this.errors = {};

            try {
                this.loading = true;
                const {data} = await Api.post('/accommodation-payment', {
                    matricule: this.data.matricule,
                    region: this.data.region?.id
                });

                this.fullnameToVerify = data.fullname;
                this.paymentLink = data.payment_link;
            } catch (err) {
                if (err.response.status === 422) {
                    this.errors = err.response.data.errors;
                } else {
                    ModalBus.processingError();
                }
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
